import { useEffect, useState } from "react";
import api from "../api";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Bounce, toast } from "react-toastify";
import "./tipologiaTitoli.css";

const EditTipologiaTitolo = () => {
  const [loading, setLoading] = useState(true);
  const [tipologia, setTipologia] = useState(null);

  const [form, setForm] = useState({
    titoloTipologia: "",
    descrizioneTitolo: "",
    livelloTitoloDiStudio: "",
    punteggioTitolo: "",
  });

  const [errors, setErrors] = useState({});
  const [editMode, setEditMode] = useState(false);

  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();

  useEffect(() => {
    const userRole = localStorage.getItem("userRole");

    if (userRole !== "ADMIN") {
      alert(
        "Accedi come amministratore per modificare la tipologia di titoli!"
      );

      navigate("/login");
      localStorage.clear();
      return;
    }

    if (location.state?.tipologiaTitoli) {
      const data = location.state.tipologiaTitoli;
      setTipologia(data);
      setForm({
        titoloTipologia: data.titoloTipologia || "",
        descrizioneTitolo: data.descrizioneTitolo || "",
        livelloTitoloDiStudio: data.livelloTitoloDiStudio || "",
        punteggioTitolo: data.punteggioTitolo || "",
      });
      setLoading(false);
    } else {
      toast.error("Qualcosa è andato storto!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
      setLoading(false);
    }
  }, [location.state]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (value.trim()) {
        delete newErrors[name];
      }
      return newErrors;
    });
  };

  const validate = () => {
    const inputErrors = {};
    if (!form.titoloTipologia.trim()) {
      inputErrors.titoloTipologia =
        "Il campo Titolo Tipologia non può essere vuoto!";
    }

    if (!form.descrizioneTitolo.trim()) {
      inputErrors.descrizioneTitolo =
        "Il campo Descrizione Titolo non può essere vuoto!";
    }

    if (!form.livelloTitoloDiStudio.trim()) {
      inputErrors.livelloTitoloDiStudio =
        "Il campo Livello Titolo di Studio non può essere vuoto!";
    }

    setErrors(inputErrors);
    return Object.keys(inputErrors).length === 0;
  };

  const handleSave = async () => {
    if (!validate()) return;

    try {
      setLoading(true);
      const payload = {
        titoloTipologia: form.titoloTipologia,
        descrizioneTitolo: form.descrizioneTitolo,
        livelloTitoloDiStudio: form.livelloTitoloDiStudio,
      };

      const response = await api.put(`/tipologia-titoli/${id}`, payload);
      if (response.status === 200) {
        toast.success("Modifiche salvate con successo!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
        setTipologia(payload);
        setEditMode(false);
      } else {
        toast.error("Qualcosa è andato storto!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      }
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    if (tipologia) {
      setForm({
        titoloTipologia: tipologia.titoloTipologia || "",
        descrizioneTitolo: tipologia.descrizioneTitolo || "",
        livelloTitoloDiStudio: tipologia.livelloTitoloDiStudio || "",
        punteggioTitolo: tipologia.punteggioTitolo || "",
      });
    }
    setErrors({});
    setEditMode(false);
  };

  return (
    <div className="content-page">
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}

      <div className="page-header">
        <div className="page-title">Modifica Tipologia Titolo</div>
        <div className="header-actions">
          <button
            onClick={() => navigate("/tipologia-titolo")}
            className="back-btn"
          >
            <i className="fa-solid fa-arrow-left"></i>
            Torna alle Tipologie
          </button>
        </div>
      </div>

      <div className="page-content edit-tipologia-container">
        <div className="edit-tipologia-card">
          <div className="card-header">
            <div className="card-title">
              <i className="fa-solid fa-graduation-cap"></i>
              Dettagli Tipologia Titolo
            </div>
            {!editMode && (
              <button className="edit-btn" onClick={() => setEditMode(true)}>
                <i className="fa-solid fa-edit"></i>
                Modifica
              </button>
            )}
          </div>

          <div className="card-content">
            {tipologia && (
              <div className="form-grid">
                <div className="form-field">
                  <label className="field-label">
                    <i className="fa-solid fa-certificate"></i>
                    Tipologia Titolo
                  </label>
                  <div className="field-input">
                    {!editMode ? (
                      <div className="readonly-value">
                        {tipologia.titoloTipologia}
                      </div>
                    ) : (
                      <input
                        type="text"
                        name="titoloTipologia"
                        value={form.titoloTipologia}
                        onChange={handleChange}
                        placeholder="Inserisci la tipologia titolo"
                        className={errors.titoloTipologia ? "error-input" : ""}
                      />
                    )}
                    {errors.titoloTipologia && (
                      <div className="error-message">
                        {errors.titoloTipologia}
                      </div>
                    )}
                  </div>
                </div>

                <div className="form-field">
                  <label className="field-label">
                    <i className="fa-solid fa-layer-group"></i>
                    Livello Titolo di Studio
                  </label>
                  <div className="field-input">
                    {!editMode ? (
                      <div className="readonly-value">
                        {tipologia.livelloTitoloDiStudio}
                      </div>
                    ) : (
                      <input
                        type="text"
                        name="livelloTitoloDiStudio"
                        value={form.livelloTitoloDiStudio}
                        onChange={handleChange}
                        placeholder="Inserisci il livello titolo di studio"
                        className={
                          errors.livelloTitoloDiStudio ? "error-input" : ""
                        }
                      />
                    )}
                    {errors.livelloTitoloDiStudio && (
                      <div className="error-message">
                        {errors.livelloTitoloDiStudio}
                      </div>
                    )}
                  </div>
                </div>

                <div className="form-field">
                  <label className="field-label">
                    <i className="fa-solid fa-star"></i>
                    Punteggio Titolo
                  </label>
                  <div className="field-input">
                    <div className="readonly-value">
                      {tipologia.punteggioTitolo || "0"}
                    </div>
                  </div>
                </div>

                <div className="form-field full-width">
                  <label className="field-label">
                    <i className="fa-solid fa-align-left"></i>
                    Descrizione Titolo
                  </label>
                  <div className="field-input">
                    {!editMode ? (
                      <div className="readonly-value">
                        {tipologia.descrizioneTitolo}
                      </div>
                    ) : (
                      <textarea
                        name="descrizioneTitolo"
                        value={form.descrizioneTitolo}
                        onChange={handleChange}
                        rows={4}
                        placeholder="Inserisci la descrizione del titolo"
                        className={
                          errors.descrizioneTitolo ? "error-input" : ""
                        }
                      />
                    )}
                    {errors.descrizioneTitolo && (
                      <div className="error-message">
                        {errors.descrizioneTitolo}
                      </div>
                    )}
                  </div>
                </div>

                {editMode && (
                  <div className="action-buttons">
                    <button className="cancel-btn" onClick={handleCancel}>
                      <i className="fa-solid fa-times"></i>
                      Annulla
                    </button>
                    <button className="save-btn" onClick={handleSave}>
                      <i className="fa-solid fa-check"></i>
                      Salva Modifiche
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditTipologiaTitolo;
